
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conferences",
      function () {
        return require("private-next-pages/conferences/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conferences"])
      });
    }
  